import config from '../config';

/**
 * Returns the absolute URL to a file stored in Laravel public storage.
 * Dynamically resolves the API domain from config.ts and handles both
 * local development and production URLs seamlessly.
 */
export const getStorageUrl = (path: string | null | undefined, fallback: string = ''): string => {
    if (!path) return fallback;

    // If it's already a full URL, blob URL, or base64 data URL, return it as-is
    if (
        path.startsWith('http://') || 
        path.startsWith('https://') || 
        path.startsWith('blob:') || 
        path.startsWith('data:')
    ) {
        return path;
    }

    // Clean path (strip leading slash, public, app/public if present to handle variations)
    let cleanPath = path.replace(/^\//, '');
    if (cleanPath.startsWith('app/public/')) {
        cleanPath = cleanPath.substring('app/public/'.length);
    }
    if (cleanPath.startsWith('public/')) {
        cleanPath = cleanPath.substring('public/'.length);
    }

    // Clean base URL from config.API_URL (strip trailing /api or /public/api)
    const base = config.API_URL
        .replace(/\/api\/?$/, '')
        .replace(/\/public\/?$/, '');

    // This server serves the files straight from storage/app/public (there is no storage symlink).
    return `${base}/storage/app/public/${cleanPath}`;
};
